import DesignEditor from './DesignEditor';

export default DesignEditor;
